// extracted by mini-css-extract-plugin
export var icon = "LinksItem-module--icon--c84af";
export var link = "LinksItem-module--link--224ae";